import React from "react";
import { Box } from "@mui/material";

export const TABLE_CHECKBOX_SIZE = 18;

const createCheckboxShell = (borderRadius, borderColor, backgroundColor) => ({
  width: TABLE_CHECKBOX_SIZE,
  height: TABLE_CHECKBOX_SIZE,
  display: "flex",
  flexShrink: 0,
  alignItems: "center",
  justifyContent: "center",
  borderRadius,
  border: `1px solid ${borderColor}`,
  backgroundColor,
  boxSizing: "border-box",
});

const createCheckboxCheckmark = (width, height, borderWidth, transform) => (
  <Box
    component="span"
    sx={{
      width,
      height,
      borderRight: `${borderWidth}px solid #FFFFFF`,
      borderBottom: `${borderWidth}px solid #FFFFFF`,
      transform,
      transformOrigin: "center",
      boxSizing: "border-box",
    }}
  />
);

const createCheckboxIndeterminateIcon = (borderRadius, dashWidth, borderColor) => (
  <Box sx={createCheckboxShell(borderRadius, borderColor, "#FFFFFF")}>
    <Box
      component="span"
      sx={{
        width: dashWidth,
        height: 2,
        borderRadius: 999,
        backgroundColor: borderColor,
      }}
    />
  </Box>
);

const createCheckboxCheckedIcon = (
  borderRadius,
  checkWidth,
  checkHeight,
  borderWidth,
  transform
) => (
  <Box sx={createCheckboxShell(borderRadius, "#9C4FFF", "#9C4FFF")}>
    {createCheckboxCheckmark(checkWidth, checkHeight, borderWidth, transform)}
  </Box>
);

export const defaultCheckboxIcon = (
  <Box sx={createCheckboxShell("6px", "#D3D8E0", "#FFFFFF")} />
);

export const defaultCheckboxIndeterminateIcon = createCheckboxIndeterminateIcon(
  "6px",
  10,
  "#9C4FFF"
);

export const defaultCheckboxCheckedIcon = createCheckboxCheckedIcon(
  "6px",
  5,
  9,
  2,
  "rotate(45deg) translate(-1px, -1px)"
);

export const referenceCheckboxIcon = (
  <Box sx={createCheckboxShell("4px", "#D0D5DD", "#FFFFFF")} />
);

export const referenceCheckboxIndeterminateIcon = createCheckboxIndeterminateIcon(
  "4px",
  8,
  "#9C4FFF"
);

export const referenceCheckboxCheckedIcon = createCheckboxCheckedIcon(
  "4px",
  4,
  7,
  1.5,
  "rotate(45deg) translate(-0.5px, -0.5px)"
);
